<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { inject } from 'vue'
import {
  BodoveKriteriumMetodika,
  VyzvaSpecificationPublicResponse,
} from '/@src/client-public'

export interface BodoveKriterium {}

defineProps<BodoveKriterium>()
const { t } = useI18n()

const specResponse = inject(
  'specResponse'
) as NonNullable<VyzvaSpecificationPublicResponse>
const kriteriaData = specResponse.zoppmSpec?.bodoveKriteria

const minMaxPoceBodov = (metodika: BodoveKriteriumMetodika) => {
  if (metodika.pocetBodovMin > 0 && metodika.pocetBodovMax > 0) {
    if (metodika.pocetBodovMin === metodika.pocetBodovMax) {
      return `(${metodika.pocetBodovMax} bodov)`
    }
    return `(${metodika.pocetBodovMin}-${metodika.pocetBodovMax} bodov)`
  } else if (metodika.pocetBodovMin > 0) {
    return `(min ${metodika.pocetBodovMin} bodov)`
  } else if (metodika.pocetBodovMax > 0) {
    return `(max ${metodika.pocetBodovMax} bodov)`
  }
  return ''
}
</script>

<template>
  <template v-for="(kriterium, key) in kriteriaData" :key="key">
    <ValidationWrapper
      v-slot="slotProps"
      :name="`bodoveKriteria[${key}].zoppmBodoveKriteriumSpecRef.zoppmSpecId`"
      :value="kriterium.zoppmBodoveKriteriumSpecRef.zoppmSpecId"
    >
      <IDSKInput v-bind="slotProps" readonly hidden />
    </ValidationWrapper>
    <ValidationWrapper
      v-slot="slotProps"
      :name="`bodoveKriteria[${key}].zoppmBodoveKriteriumSpecRef.zoppmBodoveKriteriumSpecId`"
      :value="kriterium.zoppmBodoveKriteriumSpecRef.zoppmBodoveKriteriumSpecId"
    >
      <IDSKInput v-bind="slotProps" readonly hidden />
    </ValidationWrapper>
    <ValidationWrapper
      v-slot="slotProps"
      :name="`bodoveKriteria[${key}].zoppmBodoveKriteriumSpecRef.nazov`"
      :value="kriterium.zoppmBodoveKriteriumSpecRef.nazov"
    >
      <IDSKInput v-bind="slotProps" readonly hidden />
    </ValidationWrapper>

    <IDSKHeading as="h3" variant="l" class="mb-7">
      {{ key + 1 }}. {{ kriterium.zoppmBodoveKriteriumSpecRef.nazov }}
    </IDSKHeading>
    <IDSKParagraph class="mb-8">{{ kriterium.popis }}</IDSKParagraph>

    <div v-for="(metodika, metodikaKey) in kriterium.metodika" :key="metodikaKey">
      <IDSKHeading as="h4" variant="m" class="mb-6">
        {{ metodikaKey + 1 }}. {{ metodika.nazov }} {{ minMaxPoceBodov(metodika) }}
      </IDSKHeading>
      <IDSKParagraph class="mb-9">{{ metodika.popis }}</IDSKParagraph>
    </div>

    <div v-if="kriterium?.vyplnaZiadatel" class="mb-8">
      <ValidationWrapper v-slot="slotProps" :name="`bodoveKriteria[${key}].pocetBodov`">
        <IDSKInput
          v-bind="slotProps"
          :label="t('zoppm.step3.pointsLabel')"
          :hint="t('zoppm.step3.pointsHint', { points: kriterium.pocetBodovMax })"
        />
      </ValidationWrapper>
      <ValidationWrapper
        v-slot="slotProps"
        :name="`bodoveKriteria[${key}].poznamka`"
        :value="''"
      >
        <IDSKTextarea
          v-bind="slotProps"
          :label="t('zoppm.step3.noteLabel')"
          class="mb-4"
        />
      </ValidationWrapper>
    </div>

    <IDSKDivider v-if="key !== kriteriaData.length - 1" class="mb-8" />
  </template>
</template>

<style lang="scss"></style>
